module.exports = __webpack_public_path__ + "img/body-shpae.bdf826ce.svg";